import { last } from 'lodash/fp'

const units = [
  ['inches', 'in', '"'],
  ['feet', 'ft', "'"],
  ['yard', 'yd'],
  ['mile', 'mi'],

  ['millimeters', 'mm'],
  ['meters', 'm'],
  ['kilometers', 'km'],

  ['squareInches', 'sqin'],
  ['squareFeet', 'sqft'],
  ['squareMeters', 'm2']
]

export function getShortestAbbreviation (unit) {
  return last(units.find(u => u.find(uName => uName === unit)))
}

export default function getAbbreviation (unit) {
  return units.find(u => u.find(uName => uName === unit))[1]
}
